import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

const PlusIcon = ({
  color = RoutalPalette.neutral00,
  style = { width: `14px`, height: `14px`, strokeWidth: `1.5px` },
}: {
  color?: string;
  style?: React.CSSProperties;
}) => {
  return (
    <SvgIcon viewBox="0 0 14 14" style={{ ...style }}>
      <g>
        <path d="M7 1.70996V13.2901" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.2099 7.5H12.7901" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </SvgIcon>
  );
};

export default PlusIcon;
